import { ChevronLeft } from 'lucide-react';
import { memo, type ReactNode } from 'react';

import { Button } from '../button/button';

export interface StackProps {
  onBack?: () => void;
  title?: ReactNode;
  children: ReactNode;
}

export const Stack = memo(({ children, title, onBack }: StackProps) => (
  <div className='flex size-full grid-cols-1 flex-col bg-chat-background text-chat-foreground'>
    {(title || onBack) && (
      <div className='flex flex-row items-center justify-between border-b border-chat-border px-5 py-3'>
        <div className='grid w-full grid-cols-9 items-center justify-center'>
          {onBack && (
            <Button onClick={onBack} data-testid='get-back-button'>
              <ChevronLeft />
            </Button>
          )}
          {title && (
            <div className='col-span-7 text-center text-xl font-semibold'>
              {title}
            </div>
          )}
        </div>
      </div>
    )}
    <div className='h-fit overflow-y-auto p-5'>{children}</div>
  </div>
));
